<template>
  <div id="app" >
    <router-view/>
  </div>
</template>

<script>
import { queryLimit } from '@/api/base';
import connectSocket from '@/utils/connectSocket'
export default {
  name: "App",
  data () {
    return {
    };
  },
  watch:{
    '$route' (to, from) {}
  },
  created () {
    const subjectId = sessionStorage.getItem('subject_id');
    if (subjectId) this.checkLimit(subjectId);
  },
  mounted() {
    window.onpopstate = () => {
      window.history.go(-1)
    }
  },
  methods: {
    // 检测用户功能是否被限制
    async checkLimit(subjectId) {
      const params = {
        subject_id: subjectId,
        route: '/supervise/home'
      };
      const { code, msg } = await queryLimit(params);
      // 当前页面是否是无权限页面
      const isNoPermission = this.$route.path.indexOf('/supervise/noPermission') > 0;
      if (+code === 200 && isNoPermission) {
        this.$router.replace({ path: '/supervise/' });
      }
      if (+code === -9999991 && !isNoPermission) {
        this.$router.replace({ path: '/supervise/noPermission', query: { reason: msg } });
      }
    }
  }
};
</script>

<style  lang="scss">
@import "~@/assets/scss/reset";
@import "~@/assets/scss/global";
@import "~@/assets/scss/index";
[v-cloak] {
  display: none;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.limit-user-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 50%;
  border-radius: 12px;
  margin: 0;
  z-index: 100;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .tps {
      padding: 100px 0;
      font-size: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue